var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg05PatHappy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#bot{transform-origin:120px 200px;animation:squash 2.2s ease-in-out infinite}\n@keyframes squash{0%,60%,100%{transform:scale(1,1)}12%{transform:scale(1.14,.84)}26%{transform:scale(.96,1.05)}38%{transform:scale(1,1)}}\n#hand{animation:pat 2.2s ease-in-out infinite}\n@keyframes pat{0%,60%,100%{transform:translateY(-34px);opacity:0}6%{opacity:1}12%{transform:translateY(0);opacity:1}40%{transform:translateY(-34px);opacity:0}}\n.hrt{opacity:0;animation:up 2.2s ease-out infinite}\n.h2{animation-delay:.25s}\n@keyframes up{0%,10%{opacity:0;transform:translate(0,0) scale(.4)}25%{opacity:1}100%{opacity:0;transform:translate(0,-60px) scale(1.1)}}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 55,
    width: 160,
    height: 150,
    rx: 52,
    fill: "#6FE3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 122 Q90 102 106 122",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 122 Q150 102 166 122",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 150 Q120 170 138 150",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 150,
    r: 10,
    fill: "#FF9EB5",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 150,
    r: 10,
    fill: "#FF9EB5",
    opacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hand",
    fill: "#FFD1A8",
    stroke: "#0E2A2E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 4 h56 a14 14 0 0 1 14 14 v26 h-84 v-26 a14 14 0 0 1 14 -14 z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#FF6E8A"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hrt",
    d: "M196 130 c0-8 12-8 12 0 c0-8 12-8 12 0 c0 10 -12 18 -12 18 s-12-8 -12-18 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hrt h2",
    d: "M26 138 c0-7 10-7 10 0 c0-7 10-7 10 0 c0 9 -10 15 -10 15 s-10-6 -10-15 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05PatHappy);
export default __webpack_public_path__ + "static/media/05-pat-happy.362d9468fcb904305ebf6a1582b0be43.svg";
export { ForwardRef as ReactComponent };